import { memo, useContext, useMemo, useState } from 'react';

import { useOutsideClick } from 'App/hooks';

import arrowDown from '../../assets/arrow-down.svg';
import lightningArrowDown from '../../assets/lightning-arrow-down.svg';
import { AppContext } from '../../providers';

import './styles.scss';

const languageMenu = [
    { languageName: 'Português', value: 'pt', label: 'pt' },
    { languageName: 'Română', value: 'ro', label: 'ro' },
    { languageName: 'Srpski', value: 'sr', label: 'sr' },
    { languageName: 'Ελληνικά', value: 'gr', label: 'gr' },
    { languageName: 'Italiano', value: 'it', label: 'it' },
    { languageName: 'Български', value: 'bg', label: 'bg' },
    { languageName: 'English', value: 'en', label: 'en' },
    { languageName: 'English (ZA)', value: 'enza', label: 'en za' },
    { languageName: 'Español (ES)', value: 'es', label: 'es es' },
    { languageName: 'Español (PE)', value: 'espe', label: 'es pe' },
    { languageName: 'Español (CL)', value: 'escl', label: 'es cl' },
];

const LanguageSelector = ({
    phase,
    locale,
    changeLanguage,
    backgroundSelector = 'transparent',
}) => {
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);

    const {
        appConfig: { activeLanguages },
    } = useContext(AppContext);

    const { langSelectorOptions, main, region } = useMemo(() => {
        const langSelectorOptions = languageMenu.filter((option) =>
            activeLanguages.includes(option.value)
        );

        const displayLanguage =
            langSelectorOptions.find((lang) => lang.value === locale) ||
            langSelectorOptions[0] ||
            languageMenu[0];

        const [main, region] = (displayLanguage.label || '').split(' ');

        return { langSelectorOptions, main, region };
    }, [locale]);

    const outsideRef = useOutsideClick(() => setIsDropdownVisible(false));

    const handleChangeLanguage = (value) => {
        changeLanguage(value, phase === 'landing');
        setIsDropdownVisible(false);
    };

    return (
        <div className='language-dropdown' ref={outsideRef}>
            <div
                tabIndex={0}
                role='button'
                className={`language ${phase === 'landing' ? 'language--lightning' : ''}`}
                aria-label='Select language'
                aria-expanded={isDropdownVisible}
                style={{
                    backgroundColor: backgroundSelector,
                }}
                onClick={() => setIsDropdownVisible(!isDropdownVisible)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        setIsDropdownVisible(!isDropdownVisible);
                    }
                }}>
                <div className='language-info'>
                    <span>{main}</span>
                    {region && <span>({region})</span>}
                    <img
                        className={`language-arrow ${isDropdownVisible ? 'language-arrow--drowdown-is-visible' : ''}`}
                        src={
                            phase === 'landing' ? lightningArrowDown : arrowDown
                        }
                        width={16}
                        height={12}
                        alt='arrow'
                    />
                </div>
            </div>
            <div
                className={`languages-box ${isDropdownVisible ? 'visible' : ''} ${phase === 'landing' ? 'languages-box--lightning' : ''}`}>
                <ul className={isDropdownVisible ? 'visible' : 'hidden'}>
                    {langSelectorOptions.map(({ languageName, value }) => (
                        <li key={value}>
                            <button
                                data-lang={value}
                                disabled={locale === value}
                                className={'languages-box_button'}
                                onClick={() => handleChangeLanguage(value)}>
                                <span
                                    className={
                                        locale === value ? 'selected' : ''
                                    }>
                                    {languageName}
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>
            {isDropdownVisible && (
                <div
                    className={'languages-filter'}
                    onClick={() => setIsDropdownVisible(false)}
                />
            )}
        </div>
    );
};

export default memo(LanguageSelector);
